import { Button, Slider, styled } from '@mui/material'
import { Flex } from 'styles'

export const PerCentWrap = styled('div')``
export const Percent = styled('div')`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 8px;
  margin-top: 6px;
`
export const PercentItem = styled(Button)`
  min-width: 0;
  height: 22px;
  background: ${(props) => props.theme.color.bgLightGray};
  border-radius: 4px;
  color: ${(props) => props.theme.color.text70};
  font-size: 12px;
  line-height: 12px;
  ${(props) => props.theme.breakpoints.down('md')} {
    height: 36px;
  }
`
export const SliderWrap = styled(Flex)`
  width: calc(100% - 6px);
  justify-content: center;
`
export const PercentSlider = styled(Slider)(({ theme }) => ({
  marginLeft: 6,
  '& .MuiSlider-thumb': {
    height: 16,
    width: 16,
    backgroundColor: 'rgba(160, 238, 9, 1)',
    borderWidth: '3px',
    borderStyle: 'solid',
    borderColor: 'rgba(160, 238, 9, 1)',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&:before': {
      display: 'none',
    },
  },
  '& .MuiSlider-track': {
    height: 6,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(160, 238, 9, 1)' : '#538200',
    borderColor:
      theme.palette.mode === 'dark' ? 'rgba(160, 238, 9, 1)' : '#538200',
  },
  '& .MuiSlider-rail': {
    height: 6,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(57, 65, 73, 1)' : '#E9FACF',
    opacity: 1,
  },
  '& .MuiSlider-mark': {
    width: 4,
    height: 4,
    backgroundColor: 'rgba(22, 25, 30, 1)',
    borderWidth: '0',
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderRadius: '50%',
    opacity: 1,
    transform: 'translate(2px, -50%)',
    position: 'absolute',
    top: '50%',
    // ':first-of-type': {
    //   transform: 'translate(2px, -50%)',
    // },
    // ':last-of-type': {
    //   transform: 'translate(-15px, -50%)',
    // },
    '&:hover': {
      // backgroundColor: theme.palette.mode === 'dark' ? '#000' : '#e2f7c4',
    },
  },
  '& .MuiSlider-markLabel': {
    fontSize: '12px',
    color: 'rgba(123, 136, 145, 1)',
    top: '24px',
  },
  '& .MuiSlider-markActive': {},
  '& .MuiSlider-valueLabel': {
    width: 22,
    height: 22,
    fontSize: 12,
    padding: '0',
    fontWeight: 600,
    borderRadius: 12,
    backgroundColor: 'rgba(160, 238, 9, 1)',
    color: 'rgba(22, 25, 30, 1)',

    '&:before': {
      bottom: 2,
    },
  },
}))

const SliderMark = styled('span')`
  width: 4px;
  height: 4px;
`

PercentSlider.defaultProps = {
  components: {
    Mark: (props) => {
      return (
        <SliderMark
          className={props.className}
          data-index={props['data-index']}
          style={{
            ...props.style,
            left: props.style.left === '100%' ? 'unset' : props.style.left,
            right: props.style.left === '100%' ? '4px' : 'unset',
          }}
        />
      )
    },
  },
}
